import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';

/** Exact shape of CompanyStats.overview (db-mongo.js) — verified fields only. */
export interface CompanyOverview {
  totalLeads: number;
  leadsToday: number;
  dealsActive: number;
  dealsValue: number;
  dealsWon: number;
  contacts: number;
  totalStaff: number;
  onLeave: number;
  pendingLeaves: number;
  activeProjects: number;
  openTasks: number;
  doneTasks: number;
}

export interface CompanyDepartment {
  department: string;
  total: number;
  active_count: number;
}

export interface CompanyStatsResponse {
  overview: CompanyOverview;
  byDepartment: CompanyDepartment[];
}

/** CEO-only company health (GET /api/company/stats — requireSuperAdmin). */
export function useCompanyStats() {
  return useQuery({
    queryKey: ['company', 'stats'],
    queryFn: async () => {
      const { data } = await api.get<CompanyStatsResponse>('/api/company/stats');
      return data;
    },
    staleTime: 60_000,
    refetchInterval: 120_000,
  });
}
